'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGOUT_PROCESS_FORWARDING_STARTED = exports.LOGOUT_PROCESS_ERROR = exports.LOGOUT_PROCESS_SUCCESS = exports.LOGIN_CHECK_UNKNOWN_ERROR = exports.LOGIN_CHECK_TOKEN_EXPIRED = exports.LOGIN_CHECK_MISSING_TOKEN = exports.LOGIN_CHECK_INVALID_NONCE = exports.LOGIN_CHECK_FORWARDING_STARTED = exports.LOGIN_CHECK_SUCCESS = exports.LOGIN_CHECK_HASH_NOT_AVAILABLE = exports.checkHashForToken = exports.validateToken = exports.initializeLogoutProcess = exports.refreshToken = exports.isTokenStillValid = exports.authorize = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _jwtDecode = require('jwt-decode');

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _sessionStorage = require('./util/sessionStorage');

var _redirect = require('./util/redirect');

var _nonce = require('./util/nonce');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGIN_CHECK_HASH_NOT_AVAILABLE = 'LOGIN_CHECK_HASH_NOT_AVAILABLE';
var LOGIN_CHECK_SUCCESS = 'LOGIN_CHECK_SUCCESS';
var LOGIN_CHECK_FORWARDING_STARTED = 'LOGIN_CHECK_FORWARDING_STARTED';
var LOGIN_CHECK_INVALID_NONCE = 'LOGIN_CHECK_INVALID_NONCE';
var LOGIN_CHECK_MISSING_TOKEN = 'LOGIN_CHECK_MISSING_TOKEN';
var LOGIN_CHECK_TOKEN_EXPIRED = 'LOGIN_CHECK_TOKEN_EXPIRED';
var LOGIN_CHECK_UNKNOWN_ERROR = 'LOGIN_CHECK_UNKNOWN_ERROR';

var LOGOUT_PROCESS_SUCCESS = 'LOGOUT_PROCESS_SUCCESS';
var LOGOUT_PROCESS_ERROR = 'LOGOUT_PROCESS_ERROR';
var LOGOUT_PROCESS_FORWARDING_STARTED = 'LOGOUT_PROCESS_FORWARDING_STARTED';

function isTokenStillValid(token) {
  var timeOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isDecoded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isMilliseconds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var decodedToken = isDecoded ? token : (0, _jwtDecode2.default)(token);
  var currentTimestamp = isMilliseconds ? Math.round(Date.now()) + timeOffset : Math.round(Date.now() / 1000) + timeOffset;

  if (!decodedToken.exp) {
    return true;
  }

  return decodedToken.exp > currentTimestamp;
}

function validateToken(response, requiredNonce, clientId, expiryInMilliseconds) {
  var idTokenIsDecoded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (response.error) {
    return {
      type: LOGIN_CHECK_UNKNOWN_ERROR,
      clientId: clientId,
      error: response.error_description || response.error || 'Unknown error'
    };
  }

  if (!response.id_token || !response.access_token) {
    return {
      type: LOGIN_CHECK_MISSING_TOKEN,
      clientId: clientId,
      error: 'Parameters \'id_token\' or \'access_token\' are missing'
    };
  }

  var resultSuccessObject = {
    type: LOGIN_CHECK_SUCCESS,
    clientId: clientId
  };

  // Check Access Token Expiration
  if (!isTokenStillValid(response.access_token, 300, false, expiryInMilliseconds)) {
    return {
      type: LOGIN_CHECK_TOKEN_EXPIRED,
      clientId: clientId,
      error: '\'access_token\' is expired'
    };
  }

  resultSuccessObject.token = response.access_token;

  // Check ID Token (JWT) and retrieve user information
  var decodedIdToken = idTokenIsDecoded ? response.id_token : (0, _jwtDecode2.default)(response.id_token);

  if (decodedIdToken.nonce !== requiredNonce) {
    return {
      type: LOGIN_CHECK_INVALID_NONCE,
      clientId: clientId,
      error: '\'id_token\' Nonce value from IdP did not match the requested value'
    };
  }

  if (!isTokenStillValid(decodedIdToken, 0, true, expiryInMilliseconds)) {
    return {
      type: LOGIN_CHECK_TOKEN_EXPIRED,
      clientId: clientId,
      error: '\'id_token\' is expired'
    };
  }

  resultSuccessObject.idToken = decodedIdToken;

  (0, _sessionStorage.removeToken)(clientId + '_nonce');

  return resultSuccessObject;
}

function checkHashForToken(clientId, expiryInMilliseconds) {
  var hash = void 0;
  var requiredNonce = (0, _sessionStorage.getToken)(clientId + '_nonce');

  try {
    hash = window.location.hash;
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.error(err);
      /* eslint-enable no-console */
    }
  }

  if (hash) {
    var response = _qs2.default.parse(hash.substr(1));
    history.pushState('', document.title, window.location.pathname + window.location.search);

    return validateToken(response, requiredNonce, clientId, expiryInMilliseconds);
  }

  return {
    type: LOGIN_CHECK_HASH_NOT_AVAILABLE,
    clientId: clientId,
    error: 'No hash available'
  };
}

function doAjaxRequestAndValidateToken(clientId, url, method, params, tokenExpiryInMilliseconds, dummyIdToken) {
  return _axios2.default.request({
    url: url,
    method: method,
    params: params
  }).then(function (result) {
    return validateToken({ access_token: result.data, id_token: _extends({}, dummyIdToken, { nonce: params.nonce }) }, params.nonce, clientId, tokenExpiryInMilliseconds, true);
  }).catch(function (errorResult) {
    return {
      clientId: clientId,
      type: LOGIN_CHECK_UNKNOWN_ERROR,
      error: 'Error fetching token from AJAX API: ' + errorResult
    };
  });
}

function refreshToken(config, clientId) {
  var nonce = (0, _nonce.createNonce)();
  (0, _sessionStorage.setToken)(clientId + '_nonce', nonce);

  var params = _extends({}, config.loginParameter, {
    client_id: config.client_id,
    nonce: nonce
  });

  if (config.ajaxSupport.refresh) {
    return doAjaxRequestAndValidateToken(clientId, config.loginUrl, config.ajaxSupport.refreshMethod || 'GET', params, config.expiryInMilliseconds, config.dummyIdToken);
  }

  (0, _redirect.redirect)(config.loginUrl, params);

  return {
    clientId: clientId,
    type: LOGIN_CHECK_FORWARDING_STARTED
  };
}

function authorize(config, clientId) {
  var autoRedirectToIdp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // Try to restore from localStorage
  if ((0, _sessionStorage.hasToken)(clientId) && (0, _sessionStorage.hasToken)(clientId + '_idToken')) {
    if (!isTokenStillValid((0, _sessionStorage.getToken)(clientId), 0, false, config.expiryInMilliseconds)) {
      (0, _sessionStorage.removeToken)(clientId);
      (0, _sessionStorage.removeToken)(clientId + '_idToken');
    } else {
      return {
        type: LOGIN_CHECK_SUCCESS,
        clientId: clientId,
        token: (0, _sessionStorage.getToken)(clientId),
        idToken: JSON.parse((0, _sessionStorage.getToken)(clientId + '_idToken'))
      };
    }
  }

  var hashCheck = checkHashForToken(clientId, config.expiryInMilliseconds);

  if (hashCheck.type !== LOGIN_CHECK_HASH_NOT_AVAILABLE) {
    return hashCheck;
  }

  var nonce = (0, _nonce.createNonce)();
  (0, _sessionStorage.setToken)(clientId + '_nonce', nonce);

  var params = _extends({}, config.loginParameter, {
    client_id: config.client_id,
    nonce: nonce
  });

  if (config.ajaxSupport.login) {
    return doAjaxRequestAndValidateToken(clientId, config.loginUrl, config.ajaxSupport.loginMethod || 'GET', params, config.expiryInMilliseconds, config.dummyIdToken);
  } else if (autoRedirectToIdp) {
    (0, _redirect.redirect)(config.loginUrl, params);

    return {
      type: LOGIN_CHECK_FORWARDING_STARTED,
      clientId: clientId
    };
  }

  return hashCheck;
}

function initializeLogoutProcess(config, clientId) {
  if (!config.logoutUrl) {
    return {
      type: LOGOUT_PROCESS_SUCCESS,
      clientId: clientId
    };
  } else if (config.ajaxSupport.logout) {
    return _axios2.default.get(config.logoutUrl, { withCredentials: true }).then(function () {
      return {
        type: LOGOUT_PROCESS_SUCCESS,
        clientId: clientId
      };
    }).catch(function (errorResult) {
      return {
        type: LOGOUT_PROCESS_ERROR,
        clientId: clientId,
        error: 'Error during Logout Proces: ' + errorResult
      };
    });
  }

  (0, _redirect.redirect)(config.logoutUrl);

  return {
    clientId: clientId,
    type: LOGOUT_PROCESS_FORWARDING_STARTED
  };
}

exports.default = authorize;
exports.authorize = authorize;
exports.isTokenStillValid = isTokenStillValid;
exports.refreshToken = refreshToken;
exports.initializeLogoutProcess = initializeLogoutProcess;
exports.validateToken = validateToken;
exports.checkHashForToken = checkHashForToken;
exports.LOGIN_CHECK_HASH_NOT_AVAILABLE = LOGIN_CHECK_HASH_NOT_AVAILABLE;
exports.LOGIN_CHECK_SUCCESS = LOGIN_CHECK_SUCCESS;
exports.LOGIN_CHECK_FORWARDING_STARTED = LOGIN_CHECK_FORWARDING_STARTED;
exports.LOGIN_CHECK_INVALID_NONCE = LOGIN_CHECK_INVALID_NONCE;
exports.LOGIN_CHECK_MISSING_TOKEN = LOGIN_CHECK_MISSING_TOKEN;
exports.LOGIN_CHECK_TOKEN_EXPIRED = LOGIN_CHECK_TOKEN_EXPIRED;
exports.LOGIN_CHECK_UNKNOWN_ERROR = LOGIN_CHECK_UNKNOWN_ERROR;
exports.LOGOUT_PROCESS_SUCCESS = LOGOUT_PROCESS_SUCCESS;
exports.LOGOUT_PROCESS_ERROR = LOGOUT_PROCESS_ERROR;
exports.LOGOUT_PROCESS_FORWARDING_STARTED = LOGOUT_PROCESS_FORWARDING_STARTED;